
export class ContrachequeListDTO {

  constructor(
    public verba?: string,
    public descricao?:  string,
    public parcelas?:  string,
    public saldoBC?:  string,
    public competencia?:  string,
    public valor?:  string
  ) {
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/dominios/DTO/contracheque-list.DTO.ts